module.exports = __webpack_public_path__ + "media/images/user/favicons/android-chrome-192x192-21f1e34d5aa80c06c5ba4e971c88fd29.png";